import { CdkScrollable } from '@angular/cdk/scrolling'
import { CommonModule } from '@angular/common'
import { Component, computed, effect, inject, input, signal, viewChild } from '@angular/core'
import { Data } from '@angular/router'
import { LayoutService, ScreenSize, ScreenSizeService } from '@ftr/foundation'
import {
  BranchNavItem,
  FooterLoggedOutComponent,
  HeaderLoggedOutComponent,
  SideNavShellComponent,
  toSideNavItem,
} from '@ftr/ui-core'
import { HelpMenuItemsProvider } from '@ftr/ui-help'

@Component({
  selector: 'ftr-app-layout-no-sidenav',
  templateUrl: './app-layout-no-sidenav.component.html',
  styleUrls: ['./app-layout-no-sidenav.component.css'],
  imports: [CommonModule, HeaderLoggedOutComponent, CdkScrollable, FooterLoggedOutComponent, SideNavShellComponent],
})
export class AppLayoutNoSideNavComponent {
  screenSizeService = inject(ScreenSizeService)

  constructor() {
    effect(() => {
      const isOpen = this.sideNavHelpOpen()
      const helpItems = this.helpBranchItem()

      if (isOpen && this.sideNavMode() === 'DEFAULT') {
        this.sideNavHelpOpen.set(false)
        return
      }

      if (isOpen) {
        this.sideNav()?.openBranchNav(helpItems)
      }
    })
  }

  sideNav = viewChild(SideNavShellComponent)

  routeData = input({} as Data | undefined)

  private readonly helpMenuItemsProvider = inject(HelpMenuItemsProvider)

  protected sideNavMode = computed(() => {
    const currentSize = this.screenSizeService.sizeSignal()
    if (currentSize < ScreenSize.Large) {
      return 'OVERLAY'
    }
    return 'DEFAULT'
  })

  protected helpBranchItem = computed<BranchNavItem>(() => {
    const helpSupportFlyoutItems = this.helpMenuItemsProvider.provide({ mode: 'loggedout' })
    return {
      type: 'BRANCH',
      title: 'Help & Support',
      icon: 'HelpCircleLine',
      displayMode: 'OVERLAY',
      children: helpSupportFlyoutItems().map(toSideNavItem),
    }
  })
  protected sideNavHelpOpen = signal<boolean>(false)

  protected readonly appContentWindowSelector = LayoutService.CONTENT_WINDOW_CLASS
  protected readonly appContentWindowSelectorGreyBackground = `${this.appContentWindowSelector}--grey-background`

  protected toggleHelpNavMenu(open: boolean = true): void {
    if (this.sideNavMode() === 'OVERLAY') {
      this.sideNavHelpOpen.set(open)
    }
  }
}
